import React, { useEffect, useState } from "react";
import { SubMenu } from "react-pro-sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faFileInvoiceDollar,
} from "@fortawesome/free-solid-svg-icons";
import { SidebarLink } from "../MainMenuSidebar/MainMenuSidebar";
import userJSON from "../Login/Models/userProfiles.json";
import { User } from "../Login/Models/User/User";
import { Access } from "../Login/Models/User/Access";
import { getSubLinkAccess } from "../../GlobalServices/accessLevelService";

interface BillingMenuProps {
  isCollapsed: boolean;
}

const BillingMenu: React.FC<BillingMenuProps & { isActive: boolean }> = ({
  isCollapsed,
  isActive,
}) => {
  const [user, setUser] = useState<User>(userJSON);
  const [subLinks, setSubLinks] = useState<Access>();

  useEffect(() => {
    const accessData = getSubLinkAccess(user);
    accessData.map((res) => setSubLinks(res));
  }, [user]);

  return (
    <SubMenu
      title="Fakturering"
      defaultOpen={isActive}
      label={
        <span>
          <FontAwesomeIcon
            className="MainSidebarMainCategoryIcon"
            icon={faFileInvoiceDollar}
          />
          {!isCollapsed ? "" : " Fakturering"}
        </span>
      }
      className="MainSidebarMainCategoryText"
    >
      {subLinks?.administrator === 1 || subLinks?.subMenu_billingX === 1 ? (
        <SidebarLink to="/fakturering/X" icon={faCheck} label="Kommer snart" />
      ) : null}
    </SubMenu>
  );
};

export default BillingMenu;
